import { gql } from '@common/hooks';

export const AppHeaderQuery = gql`
  query AppHeaderQuery {
    header @client {
      breadcrumbs {
        name
        path
        privateInfo
      }
    }
  }
`;

export type AppHeaderQueryResponse = {
  header: {
    breadcrumbs: {
      name: string;
      path: string;
      privateInfo: boolean;
    }[];
  };
};

export const PENDING_APPROVAL_CHAINS_QUERY = gql`
  query ApprovalChainsPendingActionListQuery {
    approvalChainsPending {
      id
      approvable {
        ... on StaffingRequest {
          id
          __typename
        }
        ... on ExtensionOffer {
          id
          __typename
        }
      }
    }
  }
`;

export type PendingApprovalChainsQueryResponse = {
  approvalChainsPending: {
    id: string;
    approvable: {
      id: string;
      __typename: 'ExtensionOffer' | 'StaffingRequest';
    };
  }[];
};
